export default __webpack_public_path__ + "2bc30b2d4bc1b1f2e96b7df52b79f1d3.png";